class VtClientReviews extends HTMLElement {
  connectedCallback() {
    this.initMarquee();
  }

  initMarquee() {
    const track = this.querySelector('[data-review-marquee] .vt-reviews__marquee-track');
    if (!track) return;

    const groups = track.querySelectorAll('.vt-reviews__marquee-group');
    if (groups.length < 2) return;

    const first = groups[0];
    const viewport = track.closest('[data-review-marquee]');
    const minWidth = (viewport?.clientWidth || window.innerWidth) * 1.2;

    if (!first.dataset.seed) {
      first.dataset.seed = first.innerHTML;
    }
    const seed = first.dataset.seed;
    first.innerHTML = seed;

    while (first.scrollWidth < minWidth) {
      first.insertAdjacentHTML('beforeend', seed);
    }

    groups.forEach((group, index) => {
      if (index > 0) group.innerHTML = first.innerHTML;
    });
  }
}

if (!customElements.get('vt-client-reviews')) {
  customElements.define('vt-client-reviews', VtClientReviews);
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('vt-client-reviews').forEach((el) => {
    if (typeof el.initMarquee === 'function') el.initMarquee();
    else el.connectedCallback?.();
  });
});

window.addEventListener(
  'resize',
  () => {
    document.querySelectorAll('vt-client-reviews').forEach((el) => el.connectedCallback?.());
  },
  { passive: true }
);
